import { trpc, useQuery } from 'client/lib/trpc';
import { QuickLaunchDialog } from 'client/components/Dialog/QuickLaunchDialog';

export const AnonymousTrialQuickLaunchPage = () => {
  const { data, status: queryStatus } = useQuery(
    trpc.account.anonymousTrialPollLaunch,
    {},
    {
      enabled: true,
      refetchInterval: 3 * 1000 /* 3s */,
      allowedStatuses: ['ok', 'not found'],
    }
  );

  let error: string | null = null;
  if (queryStatus == 'error') {
    error = 'Unexpected error';
  } else if (data?.status == 'not found') {
    error = 'Not found';
  }

  const quickLaunchData = data?.status == 'ok' ? data : null;

  return <QuickLaunchDialog data={quickLaunchData} error={error} hideBackdrop />;
};
